export default ListagemController;

/** @ngInject */
function ListagemController($state, $stateParams, Fretes) {

  var vm = this;
  this.index = parseInt($stateParams.index, 10);
  this.btnVoltar = this.index > 0;
  this.filtro = Fretes.filtro;

  validarIndex();
  ajustarCacheId();

  function validarIndex() {
    if (
      !$state.is('consulta.fretes.listagem', {index: 0}) && !Fretes.obterCache(vm.index).fretes
    ) {
      $state.go('consulta.fretes.listagem', {index: 0});
    }
  }

  function ajustarCacheId() {
    if ($state.is('consulta.fretes.listagem', {index: 0})) {
      Fretes.setarCacheId('fretes');
    }
  }

}



/** WEBPACK FOOTER **
 ** ./pages/consulta/fretes/listagem.controller.ts
 **/